// MACHINERY V2 (Stroje) — THE service-report SEVERITY TONE, in one place
// (M2.16d fix pass, review item 1).
//
// >>> ONE DERIVATION, TWO RENDERINGS. <<< "Solved is green, anything else is
// amber" was written twice: `srChips.tsx` computed `solved ? "--green" :
// "--amber"` for the Servisné správy row chip, and `prehlad/prehladEvents.ts`
// independently computed `solved ? "g" : "a"` for the Prehľad activity pip. The
// two agreed by coincidence, and the SR-row comment in prehladEvents even
// invoked the one-derivation rule while creating the second derivation. The
// RULE now lives here once; the two SHAPES it is painted in are the two maps
// below, which is the part that genuinely differs between a chip and a pip.
//
// WHY IT IS A `.ts` WITH NO JSX: `prehladEvents.ts` is a pure module by
// contract (no React, no Redux, no i18n, no DOM), so the shared rule cannot
// live inside the `.tsx` that renders the chip.
//
// IT DELIBERATELY GRADES ONLY TWO WAYS. The report status enum has more members
// than `solved`, and every one of them means "not finished" to a shop floor —
// which is what the amber arm says. Do not add a third tone here without a
// board that draws one.
import { ServiceReportStatusCode } from "../../../models/ServiceReportsModel";

/** The two severities a service report can carry on any v2 surface. */
export type SrStatusTone = "green" | "amber";

/** THE rule. Every SR colour on every v2 surface starts here. */
export const srStatusTone = (code?: ServiceReportStatusCode): SrStatusTone =>
  code === ServiceReportStatusCode.solved ? "green" : "amber";

/** The token sheet's custom-property name for a tone — what a CHIP paints with
 *  (`color-mix` against `var(--green)` / `var(--amber)`). */
export const SR_TONE_VAR: Record<SrStatusTone, string> = {
  green: "--green",
  amber: "--amber",
};

/** The `.pip-*` class suffix for a tone (machinery-v2-tokens.scss `.pip-g` /
 *  `.pip-a`) — what a PIP paints with. */
export const SR_TONE_PIP: Record<SrStatusTone, "g" | "a"> = {
  green: "g",
  amber: "a",
};
